import { Pager, SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1620. 受注案件契約タスク一覧
 * [GET] /workspaces/:identifier/sales_order_contract_tasks
 */
type Props = {
  identifier: string;
  page?: number;
  per?: number;
  sales_order_contract_task_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  subscribed?: boolean;
  sales_order_id?: number;
  archived?: boolean;
  enabled?: boolean;
};

export type SalesOrderContractTasksResponse = {
  sales_order_contract_tasks: SalesOrderContractTask[];
  pager: Pager;
}
const salesOrderContractTasks = (props: Props): Promise<SalesOrderContractTasksResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/sales_order_contract_tasks`, { params: props });
};

export const useSalesOrderContractTasks = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'sales_order_contract_tasks', { ...props }],
    queryFn: () => salesOrderContractTasks(props),
    enabled: props.enabled,
  })
}

export const useSalesOrderContractTasksInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'sales_order_contract_tasks'] });
  };

  return { invalidate };
};
